import React from 'react'

import NavBar from "./NavBar";
import Footer from "./Footer";

const AbtInvestorCharter = () => { return ( 
        <div>
      <NavBar />
      <main id="main">
      <section id="invertorCharter" class="innerPage">
            <div class="container">
                <div class="section-title">
                    <h2>കസ്റ്റമർ സർവീസ് ടൈംലൈനുകൾ</h2>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="table-responsive">
                            <table class="table table-striped table-bordered">
                                <tr>
                                    <td><i class="ri-survey-line"></i></td>
                                    <td>നിക്ഷേപക രജിസ്ട്രേഷൻ</td>
                                    <td>പ്രവൃത്തി ദിവസങ്ങളിൽ രാവിലെ 10 മുതൽ വൈകിട്ട് 6 വരെ</td>
                                </tr>
                                <tr>
                                    <td><i class="ri-video-chat-line"></i></td>
                                    <td>ഇൻവെസ്റ്റർ വി.കെ.വൈ.സി. സമയം</td>
                                    <td>പ്രവൃത്തി ദിവസങ്ങളിൽ രാവിലെ 10 മുതൽ വൈകിട്ട് 6 വരെ</td>
                                </tr>
                                <tr>
                                    <td><i class="ri-chat-check-line"></i></td>
                                    <td>നിക്ഷേപകരെ അംഗീകരിക്കൽ പ്രക്രിയ</td>
                                    <td>എല്ലാ കെ‌.വൈ‌.സി. തെളിവുകളും രേഖകളും കൃത്യമായതും സാധുതയുള്ളതുമാണെങ്കിൽ, നിക്ഷേപകരുടെ രജിസ്‌ട്രേഷൻ പൂർത്തിയാക്കി 3-4 പ്രവൃത്തി ദിവസങ്ങൾക്കുള്ളിൽ.</td>
                                </tr>
                                <tr>
                                    <td><i class="ri-time-line"></i></td>
                                    <td>ബിഡ്ഡിംഗ് സമയം</td>
                                    <td>ഓരോ ലേല സെക്യൂരിറ്റിക്കും നിശ്ചയിച്ചിട്ടുള്ള സമയം അനുസരിച്ച്</td>
                                </tr>
                                <tr>
                                    <td><i class="ri-timer-flash-line"></i></td>
                                    <td>ബിഡ് ഫണ്ടിംഗ് സമയങ്ങൾ</td>
                                    <td>അതത് ലേല സെക്യൂരിറ്റിക്കായി നെറ്റ് ബാങ്കിംഗ്/യു.പി.ഐ.-ക്കായി വ്യക്തമാക്കിയ സമയം അനുസരിച്ച്</td>
                                </tr>
                                <tr>
                                    <td><i class="ri-refund-line"></i></td>
                                    <td>അലോട്ട്മെന്‍റിൽ ഫണ്ടുകളുടെ റീഫണ്ട്</td>
                                    <td>RBI-യുടെ ലേല അലോട്ട്മെന്‍റിന് ശേഷം രണ്ട് പ്രവൃത്തി ദിവസത്തിനുള്ളിൽ</td>
                                </tr>
                                <tr>
                                    <td><i class="ri-bank-line"></i></td>
                                    <td>ബിഡ് റദ്ദാക്കിയതിന് ശേഷം ഫണ്ടുകളുടെ റീഫണ്ട്</td>
                                    <td>റദ്ദാക്കിയതിന് ശേഷം രണ്ട് പ്രവൃത്തി ദിവസത്തിനുള്ളിൽ</td>
                                </tr>
                                <tr>
                                    <td><i class="ri-government-line"></i></td>
                                    <td>സെക്യൂരിറ്റീസ് അലോട്ട്മെന്‍റ്</td>
                                    <td>ലേല അലോട്ട്മെന്‍റ് തീയതിയിൽ</td>
                                </tr>
                                <tr>
                                    <td><i class="ri-shield-check-line"></i></td>
                                    <td>ആർ‌.ഡി‌.ജി. അക്കൗണ്ടിലെ സെക്യൂരിറ്റീസ് സെറ്റിൽമെന്‍റ്</td>
                                    <td>RBI-യിൽ നിന്നുള്ള സെക്യൂരിറ്റീസ് ക്രെഡിറ്റി കഴിഞ്ഞ് ഒരു പ്രവൃത്തി ദിവസത്തിനുള്ളിൽ</td>
                                </tr>
                                <tr>
                                    <td><i class="ri-service-line"></i></td>
                                    <td>എൻ.ഡി.എസ്. ഒ.എം. പ്രവേശന രജിസ്ട്രേഷൻ</td>
                                    <td>പ്രവൃത്തി ദിവസങ്ങളിൽ രാവിലെ 10 മുതൽ വൈകിട്ട് 6 വരെ</td>
                                </tr>
                                <tr>
                                    <td><i class="ri-check-double-line"></i></td>
                                    <td>എൻ.ഡി.എസ്. ഒ.എം. പ്രവേശന അംഗീകാരം</td>
                                    <td>എൻ.ഡി.എസ്. ഒ.എം.-ലേക്ക് ആക്‌സസ് ചെയ്യാനുള്ള നിക്ഷേപകന്‍റെ അഭ്യർത്ഥനക്ക് ശേഷം ഒരു പ്രവൃത്തി ദിവസത്തിനുള്ളിൽ</td>
                                </tr>
                                <tr>
                                    <td><i class="ri-mail-check-line"></i></td>
                                    <td>ഇ-മെയിലിൽ സ്റ്റേറ്റ്മെന്‍റ് അയയ്ക്കുക</td>
                                    <td>മാസംതോറും</td>
                                </tr>
                                <tr>
                                    <td><i class="ri-questionnaire-line"></i></td>
                                    <td>പിന്തുണ ഡെസ്ക്</td>
                                    <td>പ്രവൃത്തി ദിവസങ്ങളിൽ രാവിലെ 10 മുതൽ വൈകിട്ട് 6 വരെ</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </section>
       </main>
      <Footer />
    </div>
     ) };export default AbtInvestorCharter 
